var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',[_c('v-select',{attrs:{"hint":"Wybierz typ magazynu","items":_vm.types,"item-text":"name","item-value":"id","label":"Typ magazynu","persistent-hint":"","return-object":"","single-line":""},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }